import { createAction } from '@reduxjs/toolkit'

import {
  TKeyMetricApi,
  TKeyMetricDataBody,
  TKeyMetricRawData
} from 'types/GlobalKeyMetric'

// tryGetAllKeyMetrics
export const getAll = createAction('get_all_key_metrics')
export const getAllSuccess = createAction<TKeyMetricApi[]>(
  'get_all_key_metrics_success'
)
export const getAllFailed = createAction('get_all_key_metrics_failed')

// tryCreateKeyMetric
export const create = createAction('create_key_metric')
export const createSuccess = createAction<TKeyMetricApi>(
  'create_key_metric_success'
)
export const createFailed = createAction('create_key_metric_failed')

// tryUpdateKeyMetric
export const update = createAction('update_key_metric')
export const updateSuccess = createAction<TKeyMetricApi>(
  'update_key_metric_success'
)
export const updateFailed = createAction('update_key_metric_failed')

// clearRawData
export const clearRawData = createAction<string>('clear_key_metric_raw_data')

// tryDeleteKeyMetric
export const destroy = createAction('delete_key_metric')
export const destroySuccess = createAction<{
  id: string
  parentId: string | null
}>('delete_key_metric_success')
export const destroyFailed = createAction('delete_key_metric_failed')

// tryUpdateOrderKeyMetric
export const updateOrder = createAction('update_order_key_metric')
export const updateOrderSuccess = createAction<TKeyMetricApi[]>(
  'update_order_key_metric_success'
)
export const updateOrderFailed = createAction('update_order_key_metric_failed')

// tryPinKeyMetric / tryUnpinKeyMetric
export const pin = createAction('pin_key_metric')
export const pinSuccess = createAction<TKeyMetricApi[]>(
  'pin_key_metric_success'
)
export const pinFailed = createAction('pin_key_metric_failed')

// tryGetKeyMetricData
export const getOneRaw = createAction<{
  id: string
  body?: TKeyMetricDataBody
}>('get_one_key_metric_raw')
export const getOneRawSuccess = createAction<{
  body?: TKeyMetricDataBody
  data: TKeyMetricRawData
  id: string
}>('get_one_key_metric_raw_success')
export const getOneRawFailed = createAction<{
  id: string
  body?: TKeyMetricDataBody
  status: number | null
}>('get_one_key_metric_raw_failed')
